export enum MealType {
  NonVeg = 0,
  Vegan = 1,
  Vegetarian = 2,
}
